<select *ngIf="(currentTeamNumber >= 0) && teams"
        [(ngModel)]="currentTeamNumber"
        (ngModelChange)="onTeamChange($event)">
  <option *ngFor="let team of teams" [ngValue]="team.teamNumber">
    {{team.name}}
  </option>
</select>
